import {useEffect, useState} from "react";
import {Card, Flex} from "antd";
import {connect, useSelector} from "react-redux";
import {withRouter} from "../../../utils/services/with-router";
import {RootState} from "store/store";
import {SearchFilter,CategoryList,TopAdList } from "../components";
import {_Header} from "../components/Header";
import {AdsBanner} from "../../../shared";
import {getProductList} from "../../product/actions/Product.action";
import {useLocation} from "react-router-dom";
import {ProductListFilterModel} from "../../product/models";

const Dashboard = (props: any) => {

    const [products, setProducts] =
        useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const location = useLocation()
    const getList = () => {
        setLoading(true)
        let model:ProductListFilterModel ={
            fromIndex:'',
            fromPrice:'',
            toIndex:'',
            toPrice:'',
            searchText:'',
            subCategoryId:'',
        }
        props.getProductList(model)
            .then((data: any) => {
                if (data.payload != undefined) {

                    setProducts(data.payload.data);

                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        getList();
    }, []);
    return (
        <Flex vertical gap={"middle"}>
            <_Header/>

            <SearchFilter/>
          <CategoryList/>
            <AdsBanner/>
            <TopAdList/>
        </Flex>
    );
};

export default connect(null, {getProductList})(withRouter(Dashboard));
